import { Component, OnInit, Inject, Input } from '@angular/core';
import { Role } from '../common/models/role';
import { LOSSTREE_HEADER, LOSSTREECOLUMNNAMES, DEFAULT_SEVERITY, GRADES } from '../common/constants/labels';
import { Router, ActivatedRoute } from '@angular/router';
import { StandarInstructionService } from '../standard-instruction/standar-instruction.service';
import { MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { expandableTableRowAnimation } from './expandable-table-row-animation';
import { LossTreeService } from './loss-tree.service';
import { DialogSuccessComponent } from '../factory-information/factory-information.component';
import * as _ from 'lodash';

@Component({
  selector: 'app-loss-tree',
  templateUrl: './loss-tree.component.html',
  styleUrls: ['./loss-tree.component.scss'],
  animations: [expandableTableRowAnimation]
})
export class LossTreeComponent implements OnInit {
  role;
  LossTreeHeader = LOSSTREE_HEADER;
  dataSource;
  editTimeout: any = null;
  isEditActive = false;
  originalText = '';
  users: any = [];
  clickedLevel1 = false;
  enableSaveBtn = false;
  displayedColumns: string[] = [
    'expandIcon',
    'Level 1',
    'Level 2',
    'Level 3',
    'Level 4',
    'Level 5',
    'Severity Grade',
    'Explanation/Example'
  ];
  selectedLevel0;
  saveDataObject = [];
  validateSG;
  loading = true;
  levelData: any = [];
  selectedLevelZero;
  rowID;
  levelOneData: any = [];
  selectedLevelOneValue: any;
  levelTwoData: any = [];
  selectedLevelTwoData: any;
  levelThreeData: any = [];
  selectedLevelThreeData: any;
  levelFourData: any = [];
  selectedLevelFourData: any;
  actualLossTreeData: any = [];
  filterData: any = [];
  btn0Clicked = false;
  btn1Clicked = false;
  btn2Clicked = false;
  btn3Clicked = false;
  btn4Clicked = false;
  constructor(private service: StandarInstructionService, public dialog: MatDialog, private losstreeservice: LossTreeService, private router: Router) { }
  /* istanbul ignore next */
  ngOnInit() {
    this.losstreeservice
      .getLossTreeData()
      .subscribe((data) => {
        this.loading = false;
        this.users = data;
        this.actualLossTreeData = data;
        this.users.forEach(element => {
          this.levelData.push(element.level0);
        });
      }, (error) => {
        this.loading = false;
      });
  }
  get isAuthorized() {
    this.role = localStorage.getItem('role');
    if (this.role === Role.qualityManager || this.role === Role.readOnlyUser) {
      return false;
    } else {
      return true;
    }
  }
  addRow(data) {
    this.selectedLevel0 = data.level0;
    if (!this.enableSaveBtn) {
      this.clickedLevel1 = true;
    }
  }
  /* istanbul ignore next */
  addChild() {
    this.openDialogPopUp();
    this.clickedLevel1 = false;
  }
  /* istanbul ignore next */
  openDialogPopUp(): void {
    const dialogRef = this.dialog.open(AddLossTreeDialogPopUpComponent, {
      data: { level0: this.selectedLevel0 }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  enableSaveBtnFn(value) {
    this.enableSaveBtn = value;
    this.clickedLevel1 = false;
  }
  getSaveData(element) {
    this.saveDataObject.push(element);
  }
  // end of add loss tree--------------------------
  // method for bulk update
  /* istanbul ignore next */
  saveLossTree(id) {
    this.enableSaveBtn = false;
    /* istanbul ignore next */
    this.losstreeservice.editLossTreeData(this.saveDataObject)
      .subscribe((response) => {
        this.enableSaveBtn = false;
        this.openDialogSuccess();
      },
        (error) => {
          this.validateSG = error.error.message;
          if (error.error.message === 'Severity Grade cannot be updated more than thrice a year!') {
            this.openDialogError(id);
          }
        });
    this.enableSaveBtn = false;
    this.saveDataObject = [];
  }
  /* istanbul ignore next */
  openDialogError(id): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      data: { name: this.validateSG }
    });
    if (this.validateSG === 'Loss Tree Already Exists!') {
      dialogRef.afterClosed().subscribe(result => {
        this.clickedLevel1 = false;
        this.enableSaveBtn = false;
      });
    } else {
      dialogRef.afterClosed().subscribe(result => {
        this.losstreeservice.reloadLossTree();
      });
    }
  }
  /* istanbul ignore next */
  openDialogSuccess() {
    this.dialog.open(DialogSuccessComponent, {
      data: { name: ' Loss Tree configuration details are saved successfully.' }
    });
    this.losstreeservice.reloadLossTree();
  }
  /*************************************Filter Analysis***********************************************/
  /* istanbul ignore next */
  selectedLevelDropDown(val) {
    this.selectedLevelZero = val;
    this.btn0Clicked = true;
    let newArr = [];
    this.filterData = this.actualLossTreeData;
    for (let i = 0; i < this.filterData.length; i++) {
      if (this.filterData[i].level0 === this.selectedLevelZero) {
        newArr = this.filterData.splice(i, 1);
      }
    }
    this.users = newArr;
    this.filterData = this.actualLossTreeData;
    newArr[0].lossTreeParent.forEach(element => {
      this.levelOneData.push(element.level1);
    });
    this.levelOneData = Array.from(new Set(this.levelOneData));
  }
  /* istanbul ignore next */
  selectedLevelOne(levelOneVal) {
    this.selectedLevelOneValue = levelOneVal;
    this.btn1Clicked = true;
    const newParr = this.users;
    const newArr = [];
    for (let i = 0; i < this.users[0].lossTreeParent.length; i++) {
      if (this.users[0].lossTreeParent[i].level1 === this.selectedLevelOneValue) {
        // this.users[0].lossTreeParent.splice(i, 1);
        newArr.push(i);
      }
    }

    this.users[0].lossTreeParent = newParr[0].lossTreeParent.splice(newArr[0], (newArr.length));
    this.users[0].lossTreeParent.forEach(element => {
      this.levelTwoData.push(element.level2);
    });
    this.levelTwoData = Array.from(new Set(this.levelTwoData));
  }
  /* istanbul ignore next */
  selectedLevelTwo(levelTwoVal) {
    this.selectedLevelTwoData = levelTwoVal;
    this.btn2Clicked = true;
    const newArr = [];
    const newParr = this.users;
    for (let i = 0; i < this.users[0].lossTreeParent.length; i++) {
      if (this.users[0].lossTreeParent[i].level2 === this.selectedLevelTwoData) {
        // this.users[0].lossTreeParent.splice(i, 1);
        newArr.push(i);
      }
    }
    this.users[0].lossTreeParent = newParr[0].lossTreeParent.splice(newArr[0], (newArr.length));
    this.users[0].lossTreeParent.forEach(element => {
      this.levelThreeData.push(element.level3);
    });
    this.levelThreeData = Array.from(new Set(this.levelThreeData));
  }
  /* istanbul ignore next */
  selectedLevelThree(levelThreeVal) {
    this.selectedLevelThreeData = levelThreeVal;
    this.btn3Clicked = true;
    const newArr = [];
    const newParr = this.users;
    for (let i = 0; i < this.users[0].lossTreeParent.length; i++) {
      if (this.users[0].lossTreeParent[i].level3 === this.selectedLevelThreeData) {
        // this.users[0].lossTreeParent.splice(i, 1);
        newArr.push(i);
      }
    }
    this.users[0].lossTreeParent = newParr[0].lossTreeParent.splice(newArr[0], (newArr.length));
    this.users[0].lossTreeParent.forEach(element => {
      this.levelFourData.push(element.level4);
    });
    this.levelFourData = Array.from(new Set(this.levelFourData));
  }
  /* istanbul ignore next */
  selectedLevelFour(levelFourVal) {
    this.selectedLevelFourData = levelFourVal;
    this.btn4Clicked = true;
    const newArr = [];
    const newParr = this.users;
    for (let i = 0; i < this.users[0].lossTreeParent.length; i++) {
      if (this.users[0].lossTreeParent[i].level4 === this.selectedLevelFourData) {
        // this.users[0].lossTreeParent.splice(i, 1);
        newArr.push(i);
      }
    }
    this.users[0].lossTreeParent = newParr[0].lossTreeParent.splice(newArr[0], (newArr.length));
  }
  /* istanbul ignore next */
  resetFilterFunction() {
    this.losstreeservice.reloadLossTree();
  }
  /*************************************Filter Analysis End***********************************************/
}
export interface DialogData {
  level0: any;
  validateSG: any;
}
@Component({
  selector: 'app-losstree-popup-dialog',
  templateUrl: 'addlosstree-dialog.html',
  styleUrls: ['./addlosstree-dialog.scss'],
})

// Component loads the confirmation popup
export class AddLossTreeDialogPopUpComponent {
  showSeverity = false;
  rowID;
  defaultSeverity = DEFAULT_SEVERITY;
  mandatoryFieldsHasValue = false;
  level1; level2; level3; level4; level5; example;
  newLevel1 = ''; newLevel2 = ''; newLevel3 = ''; newLevel4 = ''; newLevel5 = ''; newExample = '';
  severity = GRADES;
  validateSG;
  constructor(
    public dialogRef: MatDialogRef<AddLossTreeDialogPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private losstreeservice: LossTreeService,
    private dialog: MatDialog, private router: Router) { }
  onNoClick(): void {
    this.dialogRef.close();
    this.newLevel1 = ''; this.newLevel2 = ''; this.newLevel3 = ''; this.newLevel4 = ''; this.defaultSeverity = DEFAULT_SEVERITY;
  }
  focusOutSeverityWhileAdd() {
    this.showSeverity = false;
  }
  severityDefaultValueWhileAdd() {
    this.showSeverity = !this.showSeverity;
  }
  selectedSeverityWhileAdd(value, index) {
    this.rowID = index;
    this.showSeverity = false;
    this.defaultSeverity = value.text;
    /* istanbul ignore next */
    if (this.newLevel1 !== '' && this.newLevel2 !== '' && this.newLevel3 !== '' && this.newLevel4 !== '' && this.defaultSeverity !== DEFAULT_SEVERITY) {
      this.mandatoryFieldsHasValue = true;
    } else {
      this.mandatoryFieldsHasValue = false;
    }

  }
  /* istanbul ignore next */
  level1hasValue(val) {
    this.newLevel1 = val;
    if (this.newLevel1 !== '' && this.newLevel2 !== '' && this.newLevel3 !== '' && this.newLevel4 !== '' && this.defaultSeverity !== DEFAULT_SEVERITY) {
      this.mandatoryFieldsHasValue = true;
    } else {
      this.mandatoryFieldsHasValue = false;
    }

  }
  /* istanbul ignore next */
  level2hasValue(val) {
    this.newLevel2 = val;
    if (this.newLevel1 !== '' && this.newLevel2 !== '' && this.newLevel3 !== '' && this.newLevel4 !== '' && this.defaultSeverity !== DEFAULT_SEVERITY) {
      this.mandatoryFieldsHasValue = true;
    } else {
      this.mandatoryFieldsHasValue = false;
    }
  }
  level3hasValue(e) {
    this.newLevel3 = e;
    if (this.newLevel1 !== '' && this.newLevel2 !== '' && this.newLevel3 !== '' && this.newLevel4 !== '' && this.defaultSeverity !== DEFAULT_SEVERITY) {
      this.mandatoryFieldsHasValue = true;
    } else {
      this.mandatoryFieldsHasValue = false;
    }
  }
  level4hasValue(val) {
    this.newLevel4 = val;
    if (this.newLevel1 !== '' && this.newLevel2 !== '' && this.newLevel3 !== '' && this.newLevel4 !== '' && this.defaultSeverity !== DEFAULT_SEVERITY) {
      this.mandatoryFieldsHasValue = true;
    } else {
      this.mandatoryFieldsHasValue = false;
    }

  }
  level5hasValue(val) {
    this.newLevel5 = val;
  }
  typedExample(val) {
    this.newExample = val;
  }
  /* istanbul ignore next */
  saveAddedLossTree() {
    const addLosstreeObject = [];
    addLosstreeObject.push({
      lossTreeID: null,
      level0: this.data.level0,
      level1: this.newLevel1,
      level2: this.newLevel2,
      level3: this.newLevel3,
      level4: this.newLevel4,
      level5: this.newLevel5,
      aggregation: this.newLevel1 + '>' + this.newLevel2 + '>' + this.newLevel3 + '>' + this.newLevel4,
      severityGrade: this.defaultSeverity,
      linkwithT5Z: 'No',
      explanationExamples: this.newExample
    });

    this.losstreeservice.editLossTreeData(addLosstreeObject).subscribe((response) => {
      this.validateSG = response.message;
      this.losstreeservice.reloadLossTree();
      this.openDialogSuccess();
    },
      (error) => {
        this.validateSG = error.error;
        this.openDialogError();
        this.losstreeservice.reloadLossTree();
      });
  }
  /* istanbul ignore next */
  openDialogSuccess() {
    this.dialog.open(DialogSuccessComponent, {
      data: { name: ' Loss Tree configuration details are saved successfully.' }
    });
  }
  /* istanbul ignore next */
  openDialogError(): void {
    this.dialog.open(DialogOverviewExampleDialogComponent, {
      data: { name: this.validateSG }
    });
  }
}
/* istanbul ignore next */
export interface DialogData {
  name: string;
}
@Component({
  selector: 'app-dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
})

// Component loads the loss tree validation popup
/* istanbul ignore next */
export class DialogOverviewExampleDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
